import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { convertAppointmentTimeFormDataToFlatAnswers } from 'components/Assessments/helpers.uncontrolled'
import { BaseSubsectionAdapter } from '../../../adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from '../../../adapters/types'
import { SupervisoryFormData } from '../../types/SupervisoryFormData'
import { SupervisoryFormField } from '../../types/SupervisoryFormField'
import { SupervisoryAssessmentQuestionnaireItem } from '../../types/questionnaire'
import { getAppointmentTimeWithTimezone } from '../../../helpers'

// Extend dayjs with required plugins for timezone functionality
dayjs.extend(utc)
dayjs.extend(timezone)

/**
 * Assessment Overview subsection adapter
 * Handles appointment time extraction and transformation with timezone support
 */
export class AssessmentOverviewAdapter extends BaseSubsectionAdapter<SupervisoryFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    options: AdapterOptions
  ): Partial<SupervisoryFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    const appointmentTime = getAppointmentTimeWithTimezone(
      flatAnswersArray,
      options.caregiverTimezone
    )

    return {
      [SupervisoryFormField.APPOINTMENT_TIME]: appointmentTime
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    // Build appointment time mutations
    if (this.formDataFieldExists(SupervisoryFormField.APPOINTMENT_TIME)) {
      const appointmentTime = this.getFormDataField(SupervisoryFormField.APPOINTMENT_TIME) ?? [
        undefined,
        undefined
      ]
      const { appointmentTimeValues } = convertAppointmentTimeFormDataToFlatAnswers(appointmentTime)

      mutations.push(
        {
          linkId: SupervisoryAssessmentQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_START,
          value: appointmentTimeValues.at(0)
        },
        {
          linkId: SupervisoryAssessmentQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_END,
          value: appointmentTimeValues.at(1)
        }
      )
    }

    return mutations
  }
}
